import { atom } from 'jotai';

import type { Location } from '@core/Entities/Search/LocationState.entity';

interface LocationHubPostcodeAtom {
  postcode: string;
  location: Location;
  isValid: boolean;
  error: boolean;
}

export const locationHubPostcodeAtom = atom<LocationHubPostcodeAtom>({
  postcode: '',
  location: {
    lat: 0,
    lon: 0,
  },
  isValid: false,
  error: false,
});
